import React, {  } from 'react';
import styles from '../Wyszukiwarka.module.css';
import { useZamowienia } from 'hooks/useZamowienia';


  export default function Szerokosc({szerokosc, setSzerokosc} ){

        const { globalSearch } = useZamowienia();
        const handleSubmit = (event) => {
        event.preventDefault(); // Blokuje przeładowanie strony po wciśnięciu Enter
        globalSearch();
      };
  return(
      <form onSubmit={handleSubmit} className={styles.colData_nr}>

      <label className={styles.labelData}> Netto szer. </label>
      <input className={styles.inputData} style={{width:"80px"}} type="text"
            value={szerokosc}
            onChange={(event) => {
              const re = /^[0-9]+$/;
              if (event.target.value === '' || re.test(event.target.value)) {
              setSzerokosc(event.target.value);
              }
            }}></input>
    </form>
  );
}